<template>
  <el-col class="chart-module" :lg="12">
    <div class="sub-view" v-loading="loading">
      <el-row>
        <span style="font-weight: bold">{{ displayTitle }}</span>

        <i
          class="el-icon-close"
          v-if="$root.editMode"
          @click="$root.onClose(title)"
        ></i>
        <i class="el-icon-zoom-in" v-else @click="showPopUp()"></i>
      </el-row>
      <el-row>
        <div style="float: right">
          {{ this.$root.htmlConst.cons_223_aggregate_period }}
          <el-date-picker
            v-model="datePicker"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="〜"
            :picker-options="pickerOptions"
            @change="rebuildChart('main')"
            format="yyyy/MM/dd"
            value-format="yyyy-MM-dd"
            :clearable="false"
          >
          </el-date-picker>
        </div>
      </el-row>
      <hr />
      <el-row>
        <echarts
          :autoresize="true"
          class="chart-view"
          :option="option"
          @click="onClick"
        />
      </el-row>
      <el-dialog
        :visible.sync="popUpDisplay"
        :append-to-body="true"
        class="historyDailog"
      >
        <template slot="title">
          <el-row>
            <span style="font-weight: bold; margin-right: 10px">{{
              displayTitle
            }}</span>
          </el-row>
          <el-row>
            <div style="float: right">
              {{ this.$root.htmlConst.cons_223_aggregate_period }}
              <el-date-picker
                v-model="datePicker"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="〜"
                :picker-options="pickerOptions"
                @change="rebuildChart('popup')"
                format="yyyy/MM/dd"
                value-format="yyyy-MM-dd"
                :clearable="false"
              >
              </el-date-picker>
            </div>
          </el-row>
        </template>
        <hr />
        <echarts
          :autoresize="true"
          :option="option"
          style="height: 75vh"
          v-loading="popupLoading"
          @click="onClick"
        />
      </el-dialog>
    </div>
  </el-col>
</template>
 
<script>
import api from "@/api";
export default {
  name: "ChatbotSurveyEvaluateChart",
  props: ["title", "displayTitle"],
  data() {
    let _this = this;
    return {
      option: this.option,
      loading: this.loading,
      popupLoading: this.popupLoading,
      popUpDisplay: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "Last Month",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24 * 30);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Week",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24 * 7);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Day",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Day",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Week",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24 * 7);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24 * 7);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Month",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24 * 30);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24 * 30);

              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      datePicker: [this.$root.startDate, this.$root.endDate],
    };
  },
  mounted() {
    this.$bus.$on("changeEndMonth", (startDate, endDate) => {
      this.datePicker = [startDate, endDate];
      this.rebuildChart("main");
    });
  },
  created() {
    let self = this;
    self.loading = true;

    api.getChatbotSurveyEvaluate(self.datePicker[0], self.datePicker[1], self.$root.facetForEchart,self.$root.ageForEchart,self.$root.sexForEchart).then(
      (res) => {
        let data = res.data;
        let data_list = data.output_list;
        self.option = {
          color: ["#67C23A", "#DDDDDD", "#F56C6C"],
          tooltip: {
            trigger: "item",
            formatter: "{b} : {c} ({d}%)",
          },
          series: [
            {
              type: "pie",
              radius: "55%",
              center: ["50%", "47%"],
              data: data_list,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
        self.loading = false;
      },
      (err) => {
        console.log(err);
      }
    );
  },
  methods: {
    showPopUp() {
      this.popUpDisplay = true;
    },
    onClick(params) {
      let ageAndSexStr = '';
      if (this.$root.ageForEchart != '') {
        ageAndSexStr += "&f%5B%5D=cf_89&op%5Bcf_89%5D=~&v%5Bcf_89%5D%5B%5D=" + this.$root.ageForEchart[0];
      }
      if (this.$root.sexForEchart != '') {
        ageAndSexStr += "&f%5B%5D=cf_90&op%5Bcf_90%5D=~&v%5Bcf_90%5D%5B%5D=" + this.$root.sexForEchart[0];
      }
      if (params.name == "低評価") {
        window.open(
          this.$root.redmineUrl +
            "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
            this.datePicker[0] +
            "&v%5Bcreated_on%5D%5B%5D=" +
            this.datePicker[1] +
            "&f%5B%5D=cf_6&op%5Bcf_6%5D=%3E%3C&v%5Bcf_6%5D%5B%5D=0&v%5Bcf_6%5D%5B%5D=5&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
            + ageAndSexStr
        );
      } else if (params.name == "高評価") {
        window.open(
          this.$root.redmineUrl +
            "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
            this.datePicker[0] +
            "&v%5Bcreated_on%5D%5B%5D=" +
            this.datePicker[1] +
            "&f%5B%5D=cf_6&op%5Bcf_6%5D=%3E%3C&v%5Bcf_6%5D%5B%5D=6&v%5Bcf_6%5D%5B%5D=10&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
            + ageAndSexStr
        );
      } else {
        window.open(
          this.$root.redmineUrl +
            "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
            this.datePicker[0] +
            "&v%5Bcreated_on%5D%5B%5D=" +
            this.datePicker[1] +
            "&f%5B%5D=cf_6&op%5Bcf_6%5D=%21*&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
            + ageAndSexStr
        );
      }
    },
    rebuildChart(value) {
      let self = this;
      if (value == "main") {
        self.loading = true;
      } else {
        self.popupLoading = true;
      }

      api.getChatbotSurveyEvaluate(self.datePicker[0], self.datePicker[1], self.$root.facetForEchart,self.$root.ageForEchart,self.$root.sexForEchart).then(
        (res) => {
          let data = res.data;
          let data_list = data.output_list;
          self.option = {
            color: ["#67C23A", "#DDDDDD", "#F56C6C"],
            tooltip: {
              trigger: "item",
              formatter: "{b} : {c} ({d}%)",
            },
            series: [
              {
                type: "pie",
                radius: "55%",
                center: ["50%", "47%"],
                data: data_list,
                itemStyle: {
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
          };
          if (value == "main") {
            self.loading = false;
          } else {
            self.popupLoading = false;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
};
</script>
<style>
</style>
